'use client';

import { useEffect, useState, useRef } from 'react';
import Script from 'next/script';
import { useAuthContext } from '@ias/components/src/components/AuthProvider';

export function GTMInit() {
  const auth = useAuthContext();
  const gtmId = process.env.NEXT_PUBLIC_GTM_ID;
  const [gtmLoaded, setGtmLoaded] = useState(false);
  const scriptRenderedRef = useRef(false);

  useEffect(() => {
    if (!gtmId || gtmLoaded) {
      return;
    }

    // Wait for auth to finish initializing
    if (auth.initializing) {
      return;
    }

    // Check if user is in a login flow (about to redirect)
    // AuthGuard sets this flag when redirecting unauthenticated users from protected pages
    // Give a small delay to allow AuthProvider to reset the flag if we're on an unprotected page
    const timer = setTimeout(() => {
      // Re-check isRedirecting after delay (AuthProvider may have reset it for unprotected pages)
      if (auth.isRedirecting) {
        return;
      }

      setGtmLoaded(true);
    }, 100); // Small delay to ensure AuthProvider's reset effect has run

    return () => clearTimeout(timer);
  }, [auth.initializing, auth.authenticated, auth.isRedirecting, gtmId, gtmLoaded]);

  if (!gtmId || !gtmLoaded) {
    return null;
  }

  // Prevent multiple renders of the script component
  if (scriptRenderedRef.current) {
    return null;
  }

  scriptRenderedRef.current = true;

  return (
    <Script
      id="gtm-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');
        `
      }}
    />
  );
}
